import { UITranslations } from "./types.ts";

// UI translations (labels, headers, and static text)
const ui: Record<"en" | "zh", UITranslations> = {
  en: {
    about: "👋 About",
    aboutContent: "",
    education: "🎓 Education",
    experience: "💼 Experience",
    skills: "🛠️ Technical Skills",
    programmingLanguages: "💻 Programming Languages",
    frameworks: "📚 Frameworks / Libraries",
    databases: "🗄️ Databases",
    cloudTech: "☁️ Cloud Technologies",
    cicd: "🔄 CI / CD",
    tools: "🔧 Other Tools",
    dataPlatforms: "📊 Data Platforms",
    present: "Present",
    greeting: "What's up?\nSharon here 👋",
    intro: "I'm an AI Engineer focused on Doc Engineering & DevEx.",
    email: "Email: ",
    contact: "📬 Contact",
    yourName: "Name: ",
    message: "Message: ",
    sendMessage: "Submit",
    sending: "Sending...",
    messageSent: "Message sent successfully!",
    typeMessage: "Type your message here...",
    errorSendingMessage: "Error sending message. Please try again.",
    home: "🏠 Home",
    welcomeMessage:
      "Hi there! This is Sharon, welcome to my personal website 😊",
    visitDocs: "Visit Documentation Site",
    clickToCollapse: "Click to collapse",
    clickToExpand: "Click to expand",
    errorOops: "Oops! Something went wrong",
    errorSorry: "We're sorry for the inconvenience, but an unexpected error has occurred.",
    errorDetails: "Error Details (Development Only):",
    tryAgain: "Try Again",
    goToHome: "Go to Home",
    srOnlyMessagePlaceholder: "Please enter your message or inquiry",
  },
  zh: {
    about: "👋 簡介",
    aboutContent: "",
    education: "🎓 學歷",
    experience: "💼 工作經驗",
    skills: "🛠️ 專業技術",
    programmingLanguages: "💻 程式語言",
    frameworks: "📚 框架 / 函式庫",
    databases: "🗄️ 資料庫",
    cloudTech: "☁️ 雲端技術",
    cicd: "🔄 CI / CD",
    tools: "🔧 其他工具",
    dataPlatforms: "📊 資料平台",
    present: "至今",
    greeting: "嘿你好！\n我叫 Sharon 👋",
    intro: "是個專注於文件工程與 DevEx 的AI軟體工程師",
    email: "電子郵件: ",
    contact: "📬 聯絡表單",
    yourName: "姓名: ",
    message: "訊息: ",
    sendMessage: "發送",
    sending: "發送中...",
    messageSent: "訊息已成功發送！",
    typeMessage: "請輸入訊息...",
    errorSendingMessage: "發送訊息時出錯。請再試一次。",
    home: "🏠 首頁",
    welcomeMessage: "哈囉！我是Sharon，歡迎光臨我的個人網站 😊",
    visitDocs: "訪問文件網站",
    clickToCollapse: "點擊以折疊",
    clickToExpand: "點擊以展開",
    errorOops: "哎呀！出了點問題",
    errorSorry: "很抱歉造成您的不便，發生了未預期的錯誤。",
    errorDetails: "錯誤詳情（僅限開發階段）：",
    tryAgain: "再試一次",
    goToHome: "回首頁",
    srOnlyMessagePlaceholder: "請輸入您的訊息或問題",
  },
};

export const translations = ui;
